import React, { useEffect, useRef, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Button from '../../../components/elements/button';
import toast from 'react-hot-toast';
import Icon from '../../../components/icons';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import SelectBox from '../../../components/elements/form/selectBox';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';

interface Props {
    _ref: React.RefObject<HTMLDialogElement>
    data: any | any[];
    onUpdate?: () => void;
    onCancel?: () => void;
}

const MoveAssetModal: React.FC<Props> = ({ _ref, data, onUpdate = () => { }, onCancel = () => { } }) => {
    const assetsApi = useAssetsApi();
    const [working, setWorking] = useState<boolean>(false);
    const { control, reset, handleSubmit, formState: { errors }, watch, setValue } = useForm<any>({
        defaultValues: {
            facilityID: null,
            subFacilityID: null
        }
    });

    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
    const facilityApi: any = useFacilitiesApi();
    const facilityWatch = watch("facilityID");
    const { showLoader, hideLoader } = useAppLoader();


    const onSubmit = () => {
        const assetIDs = Array.isArray(data) ? data.map((d: any) => d.assetID) : [data.assetID];
        const payload = {
            requests: assetIDs.map((id: number) => ({
                assetID: id,
                facilityID: facilityWatch.value,
                subFacilityID: watch("subFacilityID")?.value ?? null,
            }))
        };

        showLoader();
        setWorking(true);
        assetsApi.MoveAsset(payload, (resp: any) => {
            hideLoader();
            setWorking(false);
            if (resp.code === 200) {
                toast.success(resp.message);
                onUpdate();
                onClose();
            } else {
                toast.error(resp.message);
                onUpdate();
                onClose();
            }
        }, (err: any) => {
            hideLoader();
            setWorking(false);
            toast.error('Failed to move asset');
        });
    }

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                        data: facilist
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    const getsubfacilityList = (_facilityID: any) => {
        const payload = { facilityID: _facilityID };
        facilityApi.getSubFacilityList(payload, (resp: any) => {
            let subfacilityoption: any = resp?.subFacilityList?.map((subfacilitylist: any) => {
                return {
                    label: `${subfacilitylist.subFacilityTypeName} - ${subfacilitylist.no}`,
                    value: subfacilitylist.subFacilityID,
                }
            });
            setsubfacilityoption(subfacilityoption);
        }, (error: any) => {
            console.log('error =>', error);
            setsubfacilityoption([]);
            toast.error(error);
        });

    }

    useEffect(() => {
        reset({
            facilityID: null,
            subFacilityID: null,
        });
    }, [data]);

    useEffect(() => {
        getfacilitylist();
    }, []);
    useEffect(() => {
        if (facilityWatch) {
            setValue("subFacilityID", null);
            getsubfacilityList(facilityWatch.value);

        }
    }, [facilityWatch]);

    useEffect(() => {
        const isBulk = Array.isArray(data);
        if (!isBulk && data && facilityoption.length > 0) {
            const selectedFacility = facilityoption.find((f: any) => f.value === data.facilityID);
            setValue("facilityID", selectedFacility || null);
            if (selectedFacility) {
                getsubfacilityList(selectedFacility.value);
            }
        }
    }, [data, facilityoption]);
    useEffect(() => {
        const isBulk = Array.isArray(data);
        if (!isBulk && data && subfacilitylist && subfacilitylist.length > 0) {
            const selectedSubFacility = subfacilitylist.find((sf: any) => sf.value === data.subFacilityID);
            setValue("subFacilityID", selectedSubFacility || null);
        }
    }, [data, subfacilitylist]);


    const onClose = () => {
        _ref?.current?.close();
        onCancel();
    }


    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box max-w-[90%] w-[30rem] p-0">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='flex items-center justify-between border-b border-[#8D6E63] p-4 sticky top-0 bg-white z-[1px]'>
                        <p className='text-[1.063rem] text-[#755B51] font-semibold'>Move Asset</p>
                        <button type="button" onClick={onClose} className='bg-primary text-white p-1 rounded-md'>
                            <Icon name='close' size={1.25} />
                        </button>
                    </div>

                    <div className='py-3 min-h-[30rem] px-4'>

                        <Controller
                            name="facilityID"
                            control={control}
                            rules={{ required: "Facility is required" }}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label="Select Facility"
                                    value={value}
                                    onChange={onChange}
                                    required
                                    placeholder="Choose Facility"
                                    options={facilityoption}
                                    error={errors.facilityID?.message as any}
                                />
                            )}
                        />
                        <Controller
                            name="subFacilityID"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label="Select Sub Facility"
                                    onChange={onChange}
                                    value={value}
                                    placeholder="Choose Sub Facility"
                                    options={subfacilitylist}
                                    error={errors.subFacilityID?.message as any}
                                />
                            )}
                        />
                    </div>

                    <div className='flex justify-end gap-2 border-t border-[#8D6E63] pt-2 sticky bottom-0 bg-white z-[1px] px-4 pb-4'>
                        <Button type="button" theme='secondary' onClick={() => {
                            _ref?.current?.close();
                            onClose();
                        }}>Cancel</Button>
                        <Button type="submit" working={working} >Save</Button>
                    </div>

                </form>

            </div>
            <form method="dialog" className="modal-backdrop" onClick={onClose}>

            </form>
        </dialog>
    );
};

export default MoveAssetModal;